import { Box } from '@mui/system'
import { SearchUser } from 'components/SearchUser'
import { UserProfile } from 'components/UserProfile'
import { useBugsnagMember } from 'hooks/analytics/bugsnag/useBugsnagMember'
import { LocationPaths } from 'location.types'
import { generatePath, useNavigate, PathParam } from 'react-router'
import { UserResource } from 'userResource.types'
import { IUserMin } from 'types'

export interface ICommonRightAdornmentProps<T extends UserResource> {
  onUserChangeCallback?: () => void
  userResource?: T
  userResourcePathParams?: { [key in PathParam<T>]: string | null }
  userResourceSearchParams?: URLSearchParams
}

export const CommonRightAdornment = <T extends UserResource>({
  onUserChangeCallback,
  userResource: userResourceProp,
  userResourcePathParams,
  userResourceSearchParams
}: ICommonRightAdornmentProps<T>) => {
  const { setMember: setBugsnagMember } = useBugsnagMember()
  const navigate = useNavigate()
  const userResource = userResourceProp ?? UserResource.Root

  const onUserChange = (user: IUserMin) => {
    if (!user) {
      return
    }

    onUserChangeCallback?.()

    const { email, fullName, id } = user
    setBugsnagMember({ email, fullName, id })

    const resourcePath = generatePath(userResource, userResourcePathParams)
    const path = `${LocationPaths.Users}/${user.id}/${resourcePath}`
    const queryString = userResourceSearchParams?.size ? `?${userResourceSearchParams}` : ''

    navigate(`${path}${queryString}`)
  }

  return (
    <>
      <Box sx={{ width: 450 }}>
        <SearchUser onUserSelect={onUserChange} />
      </Box>
      <UserProfile />
    </>
  )
}
